import React from 'react'
import { Icon } from '@chakra-ui/react'

const HotelSignal = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.20668 2.52101H9.29166C10.2565 2.52189 11.0942 3.18578 11.3155 4.1249C11.334 4.20319 11.4039 4.25853 11.4843 4.25871H14.6794C14.7254 4.25888 14.7697 4.2407 14.8023 4.20817C14.835 4.17565 14.8533 4.13147 14.8533 4.08539V2.34705C14.8533 1.97835 14.7068 1.62476 14.446 1.36411C14.1853 1.10345 13.8316 0.957106 13.4629 0.957276H3.03543C2.66673 0.957106 2.31307 1.10345 2.0523 1.36411C1.79153 1.62476 1.64502 1.97835 1.64502 2.34705V4.08539C1.64502 4.13147 1.66337 4.17565 1.69601 4.20817C1.72865 4.2407 1.7729 4.25888 1.81898 4.25871H5.014C5.09463 4.259 5.16472 4.20345 5.18287 4.1249C5.40413 3.18578 6.24185 2.52189 7.20668 2.52101Z"
        fill="#83B53C"
      />
      <path
        d="M1.29775 5.30188C1.11331 5.30171 0.936387 5.3749 0.805974 5.50531C0.675561 5.63573 0.60237 5.81266 0.602539 5.99709V9.64645C0.602539 9.97685 0.83509 10.2616 1.15883 10.3276C1.23961 10.3443 1.29762 10.4153 1.29775 10.4978V11.9054C1.29775 12.2893 1.609 12.6006 1.99295 12.6006C2.37691 12.6006 2.68816 12.2893 2.68816 11.9054V10.5156C2.68799 10.4695 2.70618 10.4253 2.7387 10.3926C2.77122 10.36 2.81541 10.3417 2.86148 10.3417H13.6369C13.683 10.3417 13.7271 10.36 13.7597 10.3926C13.7922 10.4253 13.8104 10.4695 13.8102 10.5156V11.9054C13.8102 12.2893 14.1215 12.6006 14.5054 12.6006C14.8894 12.6006 15.2006 12.2893 15.2006 11.9054V10.4978C15.2007 10.4153 15.2588 10.3443 15.3395 10.3276C15.6633 10.2616 15.8958 9.97685 15.8958 9.64645V5.99709C15.896 5.81266 15.8228 5.63573 15.6924 5.50531C15.562 5.3749 15.385 5.30171 15.2006 5.30188H1.29775Z"
        fill="#83B53C"
      />
    </svg>
  )
}

export default HotelSignal
